var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifepowrFullLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Lifepowr-Full-Logo-Black",
    width: 200,
    viewBox: "0 0 200 46.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#001e1e}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    transform: "translate(55.933 11.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    transform: "translate(0 .328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M113.855 28.9h3.171v20.306h10.168v2.606H113.8V28.9z",
    className: "cls-1",
    transform: "translate(-113.8 -28.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(16.618 .328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M147.371 51.812H144.2V28.9h3.171z",
    className: "cls-1",
    transform: "translate(-144.2 -28.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "translate(24.854 .328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M159.6 28.9h13.666v2.606h-10.5v7.927h9.184v2.552h-9.184v9.827H159.6z",
    className: "cls-1",
    transform: "translate(-159.6 -28.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(41.568 .328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M190.4 28.9h13.666v2.606h-10.5v7.275h9.184v2.552h-9.184v7.873h10.5v2.606H190.4z",
    className: "cls-1",
    transform: "translate(-190.4 -28.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    transform: "translate(58.275 .328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M221.2 51.812V28.9h7.216c6.451 0 8.364 3.04 8.364 7.384 0 5.1-3.171 8.144-8.746 8.144h-3.663v7.438H221.2zm6.779-9.99c3.772 0 5.576-2.063 5.576-5.429 0-3.258-1.531-4.941-5.029-4.941h-4.155v10.316h3.608z",
    className: "cls-1",
    transform: "translate(-221.2 -28.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    transform: "translate(75.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M253.6 40.41c0-7.005 3.389-12.11 10.386-12.11 7.052 0 9.73 5.213 9.73 11.349 0 6.462-2.843 12.218-10.277 12.218-7.27.001-9.839-5.593-9.839-11.457zm17-.652c0-5.539-2.023-8.851-6.669-8.851-4.319 0-7.107 3.1-7.107 9.232 0 6.408 2.624 9.069 6.833 9.069 4.32-.001 6.943-3.096 6.943-9.45z",
    className: "cls-1",
    transform: "translate(-253.6 -28.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    transform: "translate(96.672 .328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M303.77 28.9H307l5.576 19.274h.055l4.587-19.274h3.171l-5.959 22.966h-3.772L306.394 37.8h-.055l-4.1 14.062h-3.553L292.4 28.9h3.28l5.029 19.329.055.054 4.319-14.877z",
    className: "cls-1",
    transform: "translate(-292.4 -28.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    transform: "translate(127.722 .328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M349.2 51.812V28.9h7.38c6.4 0 8.2 2.66 8.2 6.732a6.754 6.754 0 0 1-4.483 6.732l5.248 9.5H362.1l-4.647-8.8a15.48 15.48 0 0 1-1.64.054h-3.389v8.687zm6.779-11.239c3.663 0 5.521-1.737 5.521-4.832s-1.531-4.289-4.975-4.289h-4.1v9.121z",
    className: "cls-1",
    transform: "translate(-349.2 -28.9)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    transform: "translate(18.709 14.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M45.355 41.572a.41.41 0 0 0-.055.273q.082.164.164.164l2.788.765-1.859 5.3 6.4-7.271a.41.41 0 0 0 .055-.273.175.175 0 0 0-.164-.164l-2.624-.711 1.472-5.955z",
    className: "cls-1",
    transform: "translate(-45.3 -33.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    transform: "translate(0 10.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M10.8 26.5s14.65 0 13.94.492c-20.281 14.432-.44 29.519-1.258 29.519-1.148 0-16.509-9.4-9.676-26.185.93-2.35-3.006-3.826-3.006-3.826z",
    className: "cls-1",
    transform: "translate(-10.8 -26.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    transform: "translate(11.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M64.193 15.52s-7.6 12.518-7.653 11.644C54.79 2.291 31.558 11.366 31.995 10.655c.6-.984 16.618-9.184 27.387 5.357 1.531 2.077 4.811-.492 4.811-.492z",
    className: "cls-1",
    transform: "translate(-31.989 -7.465)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    transform: "translate(18.51 18.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M52.742 69.686s-8.309-12.026-7.489-11.753c23.4 8.528 24.545-16.4 25.037-15.744.656.984 1.585 18.969-16.072 22.85-2.518.547-1.476 4.647-1.476 4.647z",
    className: "cls-1",
    transform: "translate(-45.196 -42.177)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifepowrFullLogoBlack);
export default __webpack_public_path__ + "static/media/Lifepowr-Full-Logo-Black.25ad83ee7ee915f2035564217920c9dc.svg";
export { ForwardRef as ReactComponent };